import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const StyledHintWrapper = styled.div`
    display: flex;
    gap: 8px;
`;

export const StyledHint = styled.div`
    ${setFontVariant("listItem3", colorsPalettes.carbon[400])}
    word-break: break-all;
    max-width: 270px;
    display: flex;
    align-items: start;
    justify-content: flex-start;
`;

export const StyledUploadContainer = styled.div`
    & .enrichment {
        height: 330px !important;
    }
`;
